import * as Api from "@api";
import * as C from "@components";
import React from "react";
import css from "./product-automation.module.scss";
import VadImage from "vadimages-nextjs-image-optimizer";
import { PageLink, PageLinkVariant } from '@components';

export const ProductAutomationSectionKeys = [
    "automation.headline",
    "automation.body",
    "automation.link",
] as const;

type ProductAutomationSectionContent = Api.Content<typeof ProductAutomationSectionKeys[number]>;

interface ProductAutomationSectionProps
{
    imageDirectory: string;
    pageContent: ProductAutomationSectionContent;
    videoName?: string;
    className?: string;
    imageIndent?: C.MediaSpecific<C.ImageCardImageIndentBasic>;
}

export const ProductAutomationSection = ({ imageDirectory, pageContent, videoName, className, imageIndent }: ProductAutomationSectionProps): React.FunctionComponentElement<ProductAutomationSectionProps> => {
        return (<C.PageSection className={className}>
            <C.Card className={css["card"]} bgColor={C.Color.Transparent} textColor={C.Color.BlackDomina}>
                <div className={css["media-container"]}>
                    <C.FixedRatioBox className={css["media"]} imageIndent={imageIndent}>
                        {
                            videoName !== undefined ?
                                <C.Video loop muted autoPlay src={`/video/${videoName}.mp4`} sourceType="video/mp4" />
                                :
                                <VadImage src={`${imageDirectory}jig.png`} alt={'Jig'} width={445} height={445} />
                        }
                    </C.FixedRatioBox>
                </div>
                <div className={css["text"]}>
                    <C.PageContent {...pageContent["automation.headline"]}  layout={{ all: { margins: { bottom: C.Margin.D20 } }, desktop: { margins: { bottom: C.Margin.D40 } } }} typography={C.Typography.H2} />
                    <C.PageContent {...pageContent["automation.body"]} layout={{ all: { margins: { bottom: C.Margin.D20 } }, desktop: { margins: { bottom: C.Margin.D40 }, maxWidth: C.Width.W388 } }} typography={C.Typography.P2} />
                    {pageContent["automation.link"]?.data && <PageLink href="/automated-filling-and-capping" variant={PageLinkVariant.Link}>
                        {pageContent["automation.link"].data}
                    </PageLink>}
                </div>
            </C.Card>
        </C.PageSection>)
}